import { HStack, Separator, Spacer, useBreakpointValue, Stack } from '@chakra-ui/react'
import type { FC } from 'react'

import BasicCardTypePopover from '@app/next/basicCardTypePopover'
import DrawerHeaderActions from '@app/pages/strategies/components/drawer/drawerHeaderActions'
import { CardTitle } from '@app/shared/cards/components'
import { DomainObjectType } from '@app/shared/cards/components/cardTypeSection'
import { PageHeaderSection } from '@app/shared/layout'
import type { DomainBasicCard } from '@app/types'

interface Props {
  basicCard: DomainBasicCard
  strategyId: string
}

const Header: FC<Props> = ({ basicCard, strategyId }) => (
  <PageHeaderSection>
    <HStack pl={4}>
      <DomainObjectType>
        <BasicCardTypePopover basicCard={basicCard} />
      </DomainObjectType>
      <Spacer />
      <DrawerHeaderActions objId={basicCard.id} objType={basicCard.classType} strategyId={strategyId} />
    </HStack>
    <Separator />
    <Stack px={4}>
      <CardTitle domainObject={basicCard} name="name" fontSize={useBreakpointValue({ base: 'lg', md: 'xl' })} />
    </Stack>
  </PageHeaderSection>
)

export default Header
